<template>
    <va-create-layout>
        <ShipmentEventShipmentItemCharge-form
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItemCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
